import { render } from "./kontak.vue?vue&type=template&id=258f336f"
import script from "./kontak.vue?vue&type=script&lang=js"
export * from "./kontak.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__